/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_In_TitleInputs */

const en_common_sign_sign_in_title = /** @type {(inputs: Common_Sign_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const zh_common_sign_sign_in_title = /** @type {(inputs: Common_Sign_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Common_Sign_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_in_title = /** @type {((inputs?: Common_Sign_Sign_In_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_In_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_sign_in_title(inputs)
	return zh_common_sign_sign_in_title(inputs)
});
export { common_sign_sign_in_title as "common.sign.sign_in_title" }